'use client';

import WalletInfoModal from './WalletInfoModal/WalletInfoModal';
import SelectWalletModal from './SelectWalletModal/SelectWalletModal';
import useWalletConnector from './useWalletConnector';

interface WalletConnectorProps {
    isMobile?: boolean;
}

export default function WalletConnector(props: WalletConnectorProps) {
    //--------------------------------------
    const { isMobile } = props;
    //--------------------------------------
    const { walletStore } = useWalletConnector();
    //--------------------------------------
    if (walletStore.isConnected === false) {
        return (
            <>
                <SelectWalletModal isMobile={isMobile} />
            </>
        );
    } else {
        return (
            <>
                <WalletInfoModal isMobile={isMobile} />
            </>
        );
    }

    //--------------------------------------
}
